import { render } from "./DeviceDetail.vue?vue&type=template&id=404ecb5c&scoped=true"
import script from "./DeviceDetail.vue?vue&type=script&lang=js"
export * from "./DeviceDetail.vue?vue&type=script&lang=js"

import "./DeviceDetail.vue?vue&type=style&index=0&id=404ecb5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404ecb5c"]])

export default __exports__